import { HintedString } from '@skippay/core/utils/types';

/* eslint-disable camelcase */
export enum GA_VERSION {
	V3,
	V4,
}

export type GAEventData = {
	eAct?: string;
	eCat: string;
	eInt?: boolean;
	eLab?: string;
	eVal?: number;
	gaVersion?: GA_VERSION;
};

export type GAEvent = {
	event: 'gaEvent';
	eventCallback: () => void;
	gaEventData: GAEventData;
};

type Ecommerce = {
	ecommerce?: {
		items: Array<{
			promotion_id: HintedString<'affil_coupon' | 'affil_promo'>;
			promotion_name?: string | undefined;
			creative_name?: string;
			creative_slot?: string;
			location_id?: string;
			user_id?: string;
		}>;
	};
};

export type GA4Event = {
	event: string;
	ecommerce?: Ecommerce['ecommerce'];
	[key: string]: string | number | boolean | Ecommerce['ecommerce'];
};

type GAPageviewBase = {
	gaVersion?: GA_VERSION;
};

export type GAPageviewData = GAPageviewBase & {
	pTitle: string;
	pUrl?: string;
};

export type GAPageview = GAPageviewData & {
	event: 'gaPageview';
	pHostname: 'skippay.cz';
};

export type GA4Pageview = GAPageviewBase & {
	event: string;
	// eslint-disable-next-line camelcase
	page_location?: string;
	// eslint-disable-next-line camelcase
	page_title?: string;

	[key: string]: string | number | boolean | undefined;
};

declare global {
	interface Window {
		dataLayer: Array<GAEvent | GA4Event | GAPageview | GA4Pageview | { gaEventData: undefined }>;
	}
}
